import type { IconData } from '@stacksjs/iconify-core'

export const airplaneEnabledSolid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m33.828 41.541l-5.11-5.703c.297-2.134.57-4.272.828-6.412l14.469 3.617a2 2 0 0 0 2.485-1.94V29.03a3.5 3.5 0 0 0-1.784-3.05l-13.945-7.845c.186-1.952.369-3.995.537-6.09a.5.5 0 0 0-.003-.106c-.683-5.23-3.32-8.013-5.197-9.354a3.59 3.59 0 0 0-4.216 0c-1.876 1.341-4.514 4.123-5.197 9.354a.5.5 0 0 0-.003.105c.169 2.096.35 4.139.537 6.091L3.284 25.978a3.5 3.5 0 0 0-1.784 3.05v2.075a2 2 0 0 0 2.485 1.94l14.469-3.617c.259 2.14.53 4.278.828 6.412l-5.11 5.703a4.5 4.5 0 0 0-1.148 3.003v1.027a1.5 1.5 0 0 0 2.036 1.4L24 43.55l8.94 3.422a1.5 1.5 0 0 0 2.036-1.401v-1.027a4.5 4.5 0 0 0-1.148-3.003\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default airplaneEnabledSolid
